<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_86_941)">
            <path d="M8 0C3.58862 0 0 3.58862 0 8C0 12.4114 3.58862 16 8 16C12.4114 16 16 12.4114 16 8C16 3.58862 12.4114 0 8 0ZM11.8047 12.1379C11.7429 12.1999 11.6694 12.2491 11.5885 12.2827C11.5076 12.3162 11.4209 12.3334 11.3334 12.3334C11.2458 12.3334 11.1591 12.3162 11.0782 12.2827C10.9973 12.2491 10.9239 12.2 10.8621 12.1379L7.52869 8.80469C7.46665 8.7429 7.41745 8.66944 7.38393 8.58855C7.35041 8.50766 7.33323 8.42094 7.33337 8.33337V4C7.33337 3.63134 7.63197 3.33337 8 3.33337C8.36803 3.33337 8.66663 3.63134 8.66663 4V8.05737L11.8047 11.1953C12.0653 11.4561 12.0653 11.8773 11.8047 12.1379Z" fill="#212121"/>
        </g>
        <defs>
            <clipPath id="clip0_86_941">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>